import { useEffect } from "react";

import { InteractionMode } from "components/server-types";
import { storeApi, useAppSelector } from "store/index";
import { selectCurrentSectionId } from "store/selectors";
import { isGroupInteractionMode } from "utils/page-utils";

export const useFetchGroupData = (
  pageId: string | null | undefined,
  interactionMode: InteractionMode,
) => {
  const sectionId = useAppSelector(selectCurrentSectionId);

  useEffect(() => {
    if (!pageId || !sectionId) {
      return;
    }

    storeApi.submissions.list({ page_id: pageId });
    storeApi.page_outcomes.list({ page_id: pageId });

    if (!isGroupInteractionMode(interactionMode)) {
      storeApi.page_groups.list({ page_id: pageId });
      storeApi.page_group_users.list({ page_group__page_id: pageId });
    } else if (interactionMode === InteractionMode.INDIVIDUAL) {
      storeApi.section_users.list({ section_id: sectionId });
    }
  }, [interactionMode, pageId, sectionId]);
};
